// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.well[data-v-3640cd24]\n{\n  margin-bottom: 0em;\n  padding: 5px;\n}\n", ""]);
// Exports
module.exports = exports;
